import { useDreamSearchFilterContext } from "@portal/app/health/_components/components/filter/DreamSearchFilterContext";
import { faCircleCalendar } from "@fortawesome/pro-duotone-svg-icons/faCircleCalendar";
import { useState } from "react";
import { useDreamSearchContext } from "@portal/app/health/_components/DreamSearchContext";
import { FilterPill } from "./OnlineClassesFilterPill";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";

export const Duration90DaysFilterPill = () => {
  const analytics = useMixpanel();
  const { filterSettings } = useDreamSearchContext();
  const { filters, setFilters } = useDreamSearchFilterContext();
  const [isActive, setIsActive] = useState(filters["program_duration_days_lte"] === 90);

  return filterSettings?.programDuration.includes("90") ? (
    <FilterPill
      onClick={() => {
        setIsActive(!isActive);
        if (!isActive) {
          void analytics.track("Dream Search - Filter", {
            featured: "Less than 90 days",
            filterGroup: "program_duration_days_lte",
            filterItem: 90,
            filters,
          });
        }
        return setFilters(({ program_duration_days_lte, ...prevFilters }) => ({
          ...prevFilters,
          program_duration_days_lte: isActive ? undefined : 90,
        }));
      }}
      isActive={isActive}
      title="Short classes"
      iconProps={{
        icon: faCircleCalendar,
        color: isActive ? "#04299E" : "#04299E70",
      }}
      data-testid="dream-search-filter-financial-aid"
    />
  ) : null;
};
